import { ApiError } from './errors';

/**
 * What to tell somebody about a failed request, in one sentence.
 *
 * The API's own message wherever there is one — it is written for the person
 * reading it ("Line 2 has only 3 left"), and replacing it with a house
 * generality is how a usable refusal becomes "Something went wrong". The
 * exceptions are the three shapes where the server's wording is either absent
 * or unhelpful: a network failure, a rate limit, and a 5xx.
 *
 * Shared by the form-level errors and the global toast so that the same failure
 * does not read differently depending on where it surfaced.
 */
export function apiErrorMessage(error: unknown): string {
  if (!(error instanceof ApiError)) {
    return 'Something went wrong. Please try again.';
  }

  if (error.isNetworkError) return error.message;
  if (error.isRateLimited) return 'Too many attempts. Wait a few minutes and try again.';
  if (error.status >= 500) return 'The server had a problem. Please try again shortly.';

  return sentenceCase(error.message);
}

export function sentenceCase(message: string): string {
  return message.charAt(0).toUpperCase() + message.slice(1);
}
